import client from '../../api/client';
import TApiResult from '../../types/api/TApiResult';
import { AxiosError } from 'axios';
import getErrorProperty from './config/getErrorProperty';
import { IncludeContentMode, TContentsResponse } from '../../api/contents';
import { TAppContentType } from '../../types/TAppContentType';
import { getAuth } from 'firebase/auth';

export { INCLUDE_CONTENT } from '../../api/contents';

export type TApiContentsResult = {
  result?: TContentsResponse;
};

export type FetchContentsParams = {
  offset?: number;
  limit?: number;
  contentTypeIds?: TAppContentType[];
  categoryId?: number;
  categorySlug?: string;
  title?: string;
  slug?: string;
  recommendedFlg?: boolean;
  categoryFlg?: boolean;
  /** none=取らない / all=全行 / video=動画のみ。未指定は none */
  includeContent?: IncludeContentMode;
};

export const fetchContents = async (
  paramsOrOffset: FetchContentsParams | number = 0,
  limit?: number,
  content_type_id?: TAppContentType[],
  category_id?: number,
  category_slug?: string,
  title?: string,
  slug?: string,
  recommended_flg?: boolean,
  category_flg?: boolean,
  include_content?: IncludeContentMode,
): Promise<TApiResult & TApiContentsResult> => {
  let params: FetchContentsParams;
  if (typeof paramsOrOffset === 'object') {
    params = paramsOrOffset;
  } else {
    params = {
      offset: paramsOrOffset,
      limit,
      contentTypeIds: content_type_id,
      categoryId: category_id,
      categorySlug: category_slug,
      title,
      slug,
      recommendedFlg: recommended_flg,
      categoryFlg: category_flg,
      includeContent: include_content,
    };
  }

  const queryTitle = params.title === '' ? undefined : params.title;
  const slugQuery = params.slug ? { slug: params.slug } : {};
  const bodyQuery = {
    content_type_id: params.contentTypeIds,
    category_id: params.categoryId,
    category_slug: params.categorySlug,
    title: queryTitle,
    skip: params.offset ?? 0,
    limit: params.limit,
    recommended_flg: params.recommendedFlg,
    content: queryTitle,
    category_flg: params.categoryFlg,
    include_content: params.includeContent,
  };
  const query = {
    query: { ...bodyQuery, ...slugQuery },
  };

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = token && { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .contents.get({ ...query, ...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: '',
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, 'fetchContents');
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
